import { render, staticRenderFns } from "./Exhibition.vue?vue&type=template&id=9a0e9974&scoped=true&"
import script from "./Exhibition.vue?vue&type=script&lang=js&"
export * from "./Exhibition.vue?vue&type=script&lang=js&"
import style0 from "./Exhibition.vue?vue&type=style&index=0&id=9a0e9974&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0e9974",
  null
  
)

export default component.exports